import {BaseModel} from '../../_base/crud';
import {CampaignDTO} from '../../models/campaignDTO.model';
import {LeaderLevelModel} from './leader-level.model';

export enum ProfileStatusType {
	Incorporation,
	Active,
	Reactivation,
	Restart,
	RestartFull
}

export function profileStatusTypeIdsToString(profileStatusTypeIds: string[]) {
	return profileStatusTypeIds.map(id => {
		switch (+id) {
			case ProfileStatusType.Incorporation:
				return "Incorporación";
			case ProfileStatusType.Active:
				return "Activa";
			case ProfileStatusType.Reactivation:
				return "Reactivación";
			case ProfileStatusType.Restart:
				return "Reiniciada";
			case ProfileStatusType.RestartFull:
				return "Reiniciada Full";
			default: {
				throw new Error(`ProfileStatusTypeIds contiene un ID = ${id} desconocido: '${profileStatusTypeIds}'.`);
			}
		}
	}).join(", ");
}

export enum ResellerStatus {
	New,
	Active,
	Leader,
	ZoneManager,
	DivisionManager,
	GigotEmployee
}

export function resellerStatusIdsToString(resellerStatusIds: string[]) {
	return resellerStatusIds.map(id => {
		switch (+id) {
			case ResellerStatus.New:
				return "Nueva (Revendedora)";
			case ResellerStatus.Active:
				return "Activa (Revendedora)";
			case ResellerStatus.Leader:
				return "Líder";
			case ResellerStatus.ZoneManager:
				return "Gerente Zonal";
			case ResellerStatus.DivisionManager:
				return "Gerente Divisional";
			case ResellerStatus.GigotEmployee:
				return "Empleado Gigot";
			default: {
				throw new Error(`ResellerStatusIds contiene un ID = ${id} desconocido: '${resellerStatusIds}'.`);
			}
		}
	}).join(", ");
}

export class ScopeModel extends BaseModel {
	id: number;
	description: string;
	averageOrderFrom: number;
	averageOrderTo: number;
	campaignId: number;
	campaign: CampaignDTO = new CampaignDTO();
	consecutiveMissedOrders: number;
	consecutiveOrders: number;
	dateFrom: string;
	dateTo: string;
    birthDateFrom: string;
    birthDateTo: string;
    leaderLevelId: number;
    leaderLevel: LeaderLevelModel;
	profileStatusTypeIds: string[];
	resellerStatusIds: string[];
	seniorityFrom: number;
	seniorityTo: number;
	status: number; // 0 = Active | 1 = Suspended | Pending = 2
	campaignLevelsIncludedIds: number[];
	campaignLevelsExcludedIds: number[];
	isFounder: boolean;

	clear() {
		this.status = 1;
	}
}
